import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import '../node_modules/bulma/css/bulma.css';
import { Outils } from './mixins/outils'
Vue.mixin(Outils);


Vue.prototype.$bus = new Vue();


window.axios = axios.create({
	baseURL: process.env.VUE_APP_API
});

window.axios.interceptors.request.use((config) => {
	let form_data = new FormData();
	if(store.state.jwt) {
		form_data.append('jwt', store.state.jwt);
	}

	for ( var key in config.data ) {
		form_data.append(key, typeof config.data[key] == 'object' ? JSON.stringify(config.data[key]) : config.data[key]);
	}
	config.data = form_data;

	return config;
});


Vue.config.productionTip = false

Vue.component('Logo',() => import('@/components/Logo.vue'));
Vue.component('Login',() => import('@/components/Login.vue'));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
